define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var issueAdminRoles = ['Issue Administrator'];
	var issueEditRoles = issueAdminRoles.concat(['Issue Editor']);
	var questionAdminRoles = ['Question Library Administrator'];
	var reviewAdminRoles = ['Operations Review Administrator'];

	csiAccess.addViewRoles({
		"OperationsReview":{
			"ORIssues":{
				"Copy":access(full(issueEditRoles)),
				"Delete":access(full(issueAdminRoles)),
				"Edit":access(full(issueEditRoles)),
				"NewOperationsIssue":access(full(issueEditRoles))
			}
		},
		"IssueLog":{
			"OperationsIssues":{
				"Copy":access(full(issueEditRoles)),
				"Delete":access(full(issueAdminRoles)),
				"Edit":access(full(issueEditRoles)),
				"NewOperationsIssue":access(full(issueEditRoles))
			}
		}
	});
});